import * as React from "react";

export default function Contact() {
  return (
    <div style={{ textAlign: "center" }}>
      <img src="https://httpstatusdogs.com/img/404.jpg" alt="" />
    </div>
  );
}
